import React from 'react';
import { CmsDestination } from '../../integrations/contentful/types';
import IconLabelVertical from '../labels/IconLabelVertical';
import { spacing } from '../../styles/theme';
import H from '../elements/H';
import { t } from '../../utils/i18n';
import { formatDateRange } from '../../utils/date';
import Spacing from '../common/Spacing';
import RouteLink from '../navigation/RouteLink';
import { Paths } from '../../urls/Paths';
import HyperLink from '../elements/HyperLink';

interface MemoryTitleProps {
  title: string;
  startDate: string;
  endDate: string;
  destination: CmsDestination;
}

const MemoryTitle: React.FunctionComponent<MemoryTitleProps> = ({
  title,
  startDate,
  endDate,
  destination
}) => {
  return (
    <div>
      <H styling="h5">{t('Lomamuisto')}</H>
      <div className="h1">
        <H styling="h1">
          <strong>{title}</strong>
        </H>
      </div>
      <div className="time-and-place">
        <IconLabelVertical icon="travel-calendar">
          {formatDateRange(new Date(startDate), new Date(endDate))}
        </IconLabelVertical>
        <Spacing left={4}>
          <RouteLink
            path={Paths.Destination}
            params={{
              slug: destination.fields.slug
            }}
          >
            <HyperLink>
              <IconLabelVertical icon="travel-pin">
                {destination.fields.title}, {destination.fields.country}
              </IconLabelVertical>
            </HyperLink>
          </RouteLink>
        </Spacing>
      </div>
      {/*language=CSS*/}
      <style jsx>{`
        .h1 {
          margin-bottom: ${spacing.one};
        }
        .time-and-place {
          display: flex;
        }
      `}</style>
    </div>
  );
};

export default MemoryTitle;
